// extracted by mini-css-extract-plugin
export var details = "_ei-0";
export var inspectorPopover = "_ei-1";